import React, { useContext, useEffect } from "react";
import { Modal, Header, Card } from "semantic-ui-react";
import GLGIcon from "./GLGIcon";
import { AppStoreContext } from "../stores/AppStore";
import { GLOBAL_MODALS } from "../stores/modals";
import "./ModalWhatsNext.css";
import { trackAction } from "../tracking";
import OnboardingActions from "../tracking/actions";
import {useTranslation} from "react-i18next";
const cardGroupStyle = { paddingBottom: "2rem" };

export default function ModalWhatsNext() {
  const appStore = useContext(AppStoreContext);
  const [t] = useTranslation();
  useEffect(() => {
    trackAction(OnboardingActions.ModaWhatsNextDisplayed)
  }, [])

  let content = (
    <>
      <p dangerouslySetInnerHTML={{ __html: t("reg_modal_body") }} />
      <Card.Group itemsPerRow={2} centered style={cardGroupStyle}>
        <div
          onClick={() => {
            trackAction(OnboardingActions.global.Click, {from: "modal-whats-next", button: "tutorial"})
            appStore.goToRedirector()
          }}
          className="whats-next-card"
        >
          <div className="whats-next-card-main">
            <GLGIcon name="book-1" size="huge" />
            <span dangerouslySetInnerHTML={{ __html: t("begin_tutorial") }} />
          </div>
        </div>
      </Card.Group>
      <div className="what-next-extras">
        <span
          className="link"
          onClick={() => {
            trackAction(OnboardingActions.global.Click, {from: "modal-whats-next", button: "remind-later"})
            appStore.globalModal = GLOBAL_MODALS.SET_REMINDER
          }}>
          {t("remind_later")}
        </span>
      </div>
    </>
  )

  return (
    <Modal
      open={true}
      closeOnEscape={false}
      closeOnDimmerClick={false}
      dimmer="blurring"
      style={{ maxWidth: 600 }}
      className="whats-next-modal"
    >
      <Modal.Content>
        <Header as="h1">
          {t("reg_modal_header")}
        </Header>
        { content }
      </Modal.Content>
    </Modal>
  );
}
